export default {
  pageTitle: '会员套餐',
  pageDesc: '同公司成员共用配额。平台套餐按价格分高低档，有效期内只能升级到更贵的套餐，不能降级；到期前可续费当前档，到期时间按套餐天数顺延。到期后回落免费档，已有数据保留，超额后不能再新建。换档开通后整份替换，有效期从现在起算，不折现。定制套餐需平台在后台开通。',
  currentTitle: '当前套餐',
  noPlan: '尚未开通套餐',
  expired: '已过期',
  fallenBackTitle: '已回落免费档',
  fallenBack: '付费套餐已到期，已自动回落免费档。已有相册、活动、问卷保留；若已超出免费限额，需升级后才能继续新建或上传。',
  soonExpireTitle: '套餐即将到期',
  soonExpire: '当前套餐将在 7 天内到期。到期后会回落免费档，建议提前续费。',
  permanent: '永久有效',
  validUntil: '有效期至 {date}',
  usageTitle: '用量',
  albums: '照片直播',
  activities: '活动',
  registrations: '问卷',
  donations: '捐款',
  nameCards: '名片',
  sms: '短信',
  storage: '云存储（照片直播）',
  unlimited: '不限',
  catalogTitle: '公开套餐',
  upgradeOrCustom: '升级或定制套餐',
  upgradeOrCustomHint: '查看可升级档位；定制套餐需定向邀请开通。',
  customInviteHint: '定制套餐不支持自助购买，需平台定向邀请开通。',
  currentBadge: '当前',
  defaultBadge: '默认',
  buy: '购买',
  upgrade: '升级开通',
  renew: '续费',
  freeActivate: '免费开通',
  cannotDowngradeFree: '已开通付费套餐，不可切换回免费版',
  cannotDowngrade: '有效期内只能升级到价格更高的套餐，不能降级',
  cannotChangeCustom: '当前为定制套餐，请联系平台在后台调整',
  buySuccess: '套餐已开通',
  renewSuccess: '续费成功，到期时间已顺延',
  buyConfirm: '开通「{name}」将替换当前套餐，有效期从现在起算，不折现、不叠加。是否继续？',
  renewConfirm: '续费「{name}」将把到期时间延长 {n} 天，剩余天数保留。是否继续？',
  priceFree: '免费',
  durationDays: '{n} 天',
  quotaAlbums: '照片直播 {n}',
  quotaActivities: '活动 {n}',
  quotaRegistrations: '问卷 {n}',
  quotaDonations: '捐款（功能开发中，敬请期待）',
  quotaNameCards: '名片（功能开发中，敬请期待）',
  quotaSms: '短信（功能开发中，敬请期待）',
  quotaStorage: '存储 {n}',
  featureComingSoon: '功能开发中，敬请期待',
  adminTitle: '会员套餐管理',
  adminDesc: '平台超管配置多档套餐。0 表示该维度不限。平台套餐可公开售卖；定制套餐仅超管定向开通。下架后不可新购，已生效订阅继续。',
  addPlan: '新增套餐',
  editPlan: '编辑套餐',
  name: '名称',
  tag: '标签',
  tagPlaceholder: '如：热门、推荐',
  tagHint: '显示在「升级或定制套餐」页的套餐卡片内，可不填',
  description: '说明',
  features: '包含功能',
  featuresPlaceholder: '每行一项，例如：\n活动微站装修\n报名问卷\n照片直播',
  featuresHint: '仅用于套餐页展示，不影响实际权限。每行一项，最多 30 条。',
  priceYuan: '价格（元）',
  duration: '有效期',
  maxActivities: '活动上限',
  maxAlbums: '照片直播',
  maxRegistrations: '问卷',
  maxDonations: '捐款',
  maxNameCards: '名片',
  maxSms: '短信限额',
  quotaComingSoonHint: '功能开发中，敬请期待',
  maxStorageGb: '存储上限（GB）',
  isDefault: '默认档',
  status: '状态',
  statusOn: '上架',
  statusOff: '下架',
  sortOrder: '排序',
  save: '保存',
  deleteConfirm: '确定删除套餐「{name}」吗？删除后租户目录不再展示，历史订单仍保留档位记录。',
  defaultCannotDelete: '必须保留且仅能有一个默认档。删除或取消默认前，请先将其他平台套餐设为默认档',
  deleted: '套餐已删除',
  grantTitle: '开通套餐',
  grantCompany: '公司',
  grantPlan: '套餐',
  grantSuccess: '已开通',
  payTitle: '微信扫码支付',
  paySuccess: '支付成功',
  payAmount: '应付金额',
  payScanTip: '请使用微信扫描二维码完成支付',
  payCountdown: '剩余 {time}',
  payFailed: '发起支付失败',
  payNoCodeUrl: '未获取到支付二维码',
  payCancelled: '订单已取消，请重新下单',
  payCancel: '取消支付',
  activationTitle: '会员开通记录',
  activationDesc: '各企业会员开通与购买记录。金额为实收；后台开通记为 ￥0。',
  activationSearch: '搜索订单号、企业或套餐名',
  purchaseTitle: '套餐购买记录',
  purchaseDesc: '本企业套餐订单，含待支付与已取消。',
  colOrderId: '订单号',
  colCompany: '企业/组织名称',
  colPlanName: '会员套餐名',
  colAmount: '金额',
  colPayMethod: '支付方式',
  colActivatedAt: '开通时间',
  colChargedAt: '充值时间',
  colPayStatus: '状态',
  payMethodWechat: '微信支付',
  payMethodAdmin: '后台开通',
  payMethodFree: '免费开通',
  subActive: '已开通',
  subExpiring: '即将到期',
  subExpired: '已到期',
  orderPaid: '已支付',
  orderPending: '待支付',
  orderCancelled: '已取消',
  zeroHint: '0 表示不限',
  category: '套餐分类',
  categoryPlatform: '平台套餐',
  categoryCustom: '定制套餐',
  categoryPlatformHint: '官网 / 企业 / 对接人公开售卖',
  categoryCustomHint: '定向邀请开通，不进入租户自助购买目录',
  allowCustomFooterLogo: '底部 Logo 自定义',
  allowCustomFooterLogoHint: '开启后，该套餐下的公司可在活动装修中替换底部 Logo',
  perkLogoOn: '可自定义活动页底部 Logo',
  perkLogoOff: '底部 Logo 使用平台默认',
  masterExemptTitle: '系统内部超管公司',
  masterExempt: '当前为系统内部超管公司，不受套餐限制，无需购买'
}
